import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { readViewAsPlan } from '@adrodd/core';

/**
 * Attach the admin "view as plan" preview request interceptor to an axios
 * instance (web only).
 *
 * When an admin has selected a preview plan — stored in localStorage by
 * EffectivePlanContext — forward it as the `X-View-As-Plan` header so the
 * backend renders its user-facing plan-gating FLAGS (chapter `locked`, is_paid,
 * daily counters) from that perspective. The header is only honoured
 * server-side for admins and never alters real access; no header is sent when
 * viewing as "Actual" (no override set).
 */
export function applyViewAsPlanInterceptor(client: AxiosInstance): void {
  client.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const viewAs = readViewAsPlan();
    if (viewAs) {
      config.headers['X-View-As-Plan'] = viewAs;
    }
    return config;
  });
}
